import { WorkVisits } from './WorkVisits.jsx';
import { WorkConversation } from './WorkConversation.jsx';
import { WorkAttachments } from './WorkAttachments.jsx';
import { WorkCompletion } from './WorkCompletion.jsx';
import { WorkInvoices } from './WorkInvoices.jsx';

/** Sections shown on /work/:id, in order. Each unit owns its own file. */
export function WorkSections(props) {
  return <>
    <WorkVisits {...props}/>
    <WorkConversation {...props}/>
    <WorkAttachments {...props}/>
    <WorkCompletion {...props}/>
    <WorkInvoices {...props}/>
  </>;
}
